import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_STORYBOARDS_BY_PROVIDER_ID_SUCCESS:
    case constants.GET_STORYBOARD_BY_ID_SUCCESS:
      return Object.assign({},
        state, {
          storyboards: action.storyboards,
          isRefreshRequired: false,
        });
    case constants.POST_STORYBOARD_SUCCESS:
      return Object.assign({},
        state, {
          newId: action.newId,
          isRefreshRequired: true,
        });
    case constants.DELETE_STORYBOARD_SUCCESS:
      return Object.assign({},
        state, {
          isRefreshRequired: true,
        });
    case constants.GET_STORYBOARDS_BY_PROVIDER_ID_ERROR:
    case constants.GET_STORYBOARD_BY_ID_ERROR:
    case constants.POST_STORYBOARD_ERROR:
    case constants.PATCH_STORYBOARD_ERROR:
    case constants.DELETE_STORYBOARD_ERROR:
      return {
        error: action.error,
      };
    case constants.PATCH_STORYBOARD_SUCCESS:
        return Object.assign({}, state, {
            isRefreshRequired: true,
          });
    default:
        return state;
  }
};
